import React from 'react';
import { makeStyles } from '@material-ui/core';

import { useIntl } from 'ha/i18n';
import { Card, CardContent, Link, Typography, units } from '@ha/dsl';
import { ContentfulImg } from 'ha/modules/Contentful/components/ContentfulImg';
import { ShortBlogData } from 'ha/modules/Hermes/types';

const useStyles = makeStyles({
  relatedArticles: {
    display: 'flex',
    overflow: 'scroll',
    whiteSpace: 'nowrap',
    paddingBottom: units.rem(0.5),
  },
  card: {
    whiteSpace: 'normal',
    minWidth: units.rem(11.25),
    maxWidth: units.rem(11.25),
    marginRight: units.rem(1),
    '&:last-child': {
      marginRight: 0,
    },
  },
  img: {
    width: '100%',
  },
  imageWrapper: {
    height: units.rem(7.875),
    width: '100%',
    overflow: 'hidden',
  },
  title: {
    marginBottom: units.rem(1),
  },
});

interface Props {
  articles: ShortBlogData[];
}

export const RelatedArticles: React.FC<Props> = ({ articles }) => {
  const classes = useStyles();
  const { T, lang } = useIntl();

  return (
    <React.Fragment>
      <Typography.H3
        component="h3"
        className={classes.title}
        data-test-locator="Pillar RelatedArticles Title"
      >
        {T('pillar_related_articles_title')}
      </Typography.H3>
      <div className={classes.relatedArticles}>
        {articles.map(article => {
          const headerImage = article.headerImageAsset || {
            fields: { url: article.headerImage },
          };
          const desc = headerImage.fields.description;
          const alt = desc ? desc[lang] || desc.en : '';
          return (
            <Card
              key={article.title}
              className={classes.card}
              elevation={3}
              data-test-locator="Pillar RelatedArticles Card"
            >
              <Link to={article.pathname}>
                <div className={classes.imageWrapper}>
                  <ContentfulImg
                    className={classes.img}
                    src={headerImage.fields.url}
                    alt={alt}
                    sizes={{ xs: '300px' }}
                  />
                </div>
                <CardContent>
                  <Typography.Paragraph component="p">
                    {article.title}
                  </Typography.Paragraph>
                </CardContent>
              </Link>
            </Card>
          );
        })}
      </div>
    </React.Fragment>
  );
};
